import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { getCartList} from "../../API/functions";

export const useGetCartNft = (walletAddress ) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["cartNft", walletAddress], 
    queryFn: () => getCartList(walletAddress),  
    
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "An error occurred");
    },
  });

  return { data, error, isLoading  };
};